import { Location } from "history";
import { ReactComponentElement, useRef } from "react";
import { useSelector } from "react-redux";
import {
  matchPath as defaultMatchPath,
  Redirect,
  useLocation
} from "react-router-dom";

import { isSignedIn } from "seneca-common/features/user/state";
import { useLocationOnMount } from "seneca-common/utils/hooks/routing";

import RedirectToAppropriateHomePage from "./RedirectToAppropriateHomePage";

export type Props = {
  children: ReactComponentElement<any, any>;
  preserveInitialSignedInState: boolean;
  redirectAuthenticatedUserTo?: string;
  path: string;
  exact?: boolean;
  matchPath?: typeof defaultMatchPath;
  location?: Location;
};

export default function SignedOutRoute({
  preserveInitialSignedInState,
  redirectAuthenticatedUserTo,
  children,
  path,
  exact,
  location: _location,
  matchPath = defaultMatchPath
}: Props) {
  const signedIn = useSelector(isSignedIn);
  const initialSignedIn = useRef(signedIn);

  const hookLocation = useLocation();
  const locationOnMount = useLocationOnMount();

  const location = _location || hookLocation;

  const match = matchPath(location.pathname, {
    path,
    exact
  });

  if (!match) {
    return null;
  }

  const userIsSignedIn = preserveInitialSignedInState
    ? initialSignedIn.current
    : signedIn;

  if (userIsSignedIn) {
    return redirectAuthenticatedUserTo &&
      location.pathname !== redirectAuthenticatedUserTo ? (
      <Redirect
        to={{
          pathname: redirectAuthenticatedUserTo,
          search: locationOnMount.search
        }}
      />
    ) : (
      <RedirectToAppropriateHomePage />
    );
  }

  return children;
}
